import React, { FunctionComponent, memo, useLayoutEffect, useRef } from 'react'

import { Input } from './atoms'

interface Props {
  hasError?: boolean
  id: string
  value: string
  placeholder?: string
  isDisabled?: boolean
}

const MIN_TEXTAREA_HEIGHT = 32

const TextAreaInput: FunctionComponent<Props> = ({ hasError, id, value, isDisabled, ...rest }) => {
  const textareaRef = useRef(null)

  useLayoutEffect(() => {
    // Reset height - important to shrink on delete
    textareaRef.current.style.height = '32px'
    // Set height
    textareaRef.current.style.height = `${Math.max(textareaRef.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`
  }, [value])

  return (
    <Input
      id={id}
      ref={textareaRef}
      as="textarea"
      error={hasError ? hasError : undefined}
      value={value || ''}
      isDisabled={isDisabled}
      {...rest}
    />
  )
}

TextAreaInput.displayName = 'TextAreaInput'

export default memo(TextAreaInput)
